import { getAIExperienceButton, getAIExperienceDropdowns } from '../floating-toolbar-button/floating-toolbar-button';

// Copied from packages/editor/editor-core/src/plugins/floating-toolbar/index.tsx

// Copied from packages/editor/editor-core/src/plugins/floating-toolbar/index.tsx

const floatingToolbarPluginKey = 'floatingToolbarPluginKey$';

/**
 * We're monkey-patching toolbarState.getConfigWithNodeInfo() in order to
 * add our button. We will be removing this hack once we implement things
 * properly.
 *
 * This is done to avoid changes to @atlaskit/editor-core and is deemed to
 * do so because toolbarState.getConfigWithNodeInfo() is never changed again
 * after init.
 *
 * Ideally we'd have access to getConfigWithNodeInfo() during this plugin
 * state init() call, but Annotation plugin state hasn't fully settled yet
 * so we had to patch it during appendTransaction().
 *
 * @param toolbarState PluginState
 * @param editorState EditorState
 * @returns ConfigWithNodeInfo|null|undefined
 */
export const patchFloatingToolbar = ({
  editorState,
  rangeConfig,
  getIntl,
  aiGlobalOptIn
}) => {
  const toolbarPlugin = editorState.plugins.find(
  // @ts-expect-error Property 'key' does not exist on type 'Plugin<any, any>'.ts(2339)
  plugin => plugin.key === floatingToolbarPluginKey);

  /* istanbul ignore next */
  if (!toolbarPlugin) {
    return;
  }
  const toolbarState = toolbarPlugin.getState(editorState);

  /* istanbul ignore next */
  if (!toolbarState) {
    return;
  }
  const originalGetConfigWithNodeInfo = toolbarState.getConfigWithNodeInfo;
  if (originalGetConfigWithNodeInfo.aiPatched) {
    return;
  }
  toolbarState.getConfigWithNodeInfo = state => {
    const toolbarConfig = originalGetConfigWithNodeInfo(state);
    if (!toolbarConfig || !toolbarConfig.config) {
      return toolbarConfig;
    }
    const {
      items
    } = toolbarConfig.config;
    if (Array.isArray(items) && items.length === 1) {
      const createCommentButton = items[0];

      // Return early if it's not the annotation create button
      // This means it's another floating toolbar that we don't want to target
      if (createCommentButton.testId !== 'ak-editor-annotation-toolbar-create-button') {
        return toolbarConfig;
      }
      const aiDropdowns = getAIExperienceDropdowns({
        intl: getIntl(),
        rangeConfig,
        aiGlobalOptIn
      });
      const aiIconButton = getAIExperienceButton({
        intl: getIntl(),
        rangeBaseGenerate: rangeConfig.baseGenerate,
        hideTitle: !!aiDropdowns.length,
        aiGlobalOptIn
      });
      const separator = {
        type: 'separator'
      };
      items.push(separator);
      items.push(aiIconButton, ...aiDropdowns);
    }
    return toolbarConfig;
  };

  // Track that we've patched it
  toolbarState.getConfigWithNodeInfo.aiPatched = true;
};